
export default {
    methods: {
        removeDuplicateConnector: function (url) {
            let rawUrl = url;

            if (rawUrl.indexOf('&amp;') > 0) {
                const raw = rawUrl.replace('&amp;', '&');
                rawUrl = this.removeDuplicateConnector(raw);
            }

            return rawUrl;
        },
        openDocs: function (documentSymbol) {
            const raw = window.letDocumentRedirectUrl;
            if (raw != null || raw != undefined) {
                let replacer = encodeURIComponent('"' + documentSymbol + '"') + '+OR+' + encodeURIComponent('"' + documentSymbol + '/*"');
                let upperCaseLanguage = 'ENGLISH';
                switch (window.currentLanguage) {
                    case 1:
                    default:
                        upperCaseLanguage = 'ENGLISH';
                        break;
                    case 2:
                        upperCaseLanguage = 'FRENCH';
                        break;
                    case 3:
                        upperCaseLanguage = 'SPANISH';
                        break;
                }


                let url = raw.replace('{0}', replacer);
                url = url.replace('{1}', upperCaseLanguage);

                let final = this.removeDuplicateConnector(url);

                console.log(final);

                window.open(final, '_blank');
            }
        },
    }

}